import { render, staticRenderFns } from "./aRmsStrategyColumnValues.vue?vue&type=template&id=1302b3a4&scoped=true"
import script from "./aRmsStrategyColumnValues.vue?vue&type=script&lang=js"
export * from "./aRmsStrategyColumnValues.vue?vue&type=script&lang=js"
import style0 from "./aRmsStrategyColumnValues.vue?vue&type=style&index=0&id=1302b3a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1302b3a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VHover})
